import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { Item } from 'Components/Grid';
import HistoryRowControls from 'Components/HistoryRowControls';
import HistoryRowListing from 'Components/HistoryRowListing';
import HistorySection from 'Components/HistorySection';
import DocumentCreationButton from 'Components/DocumentCreationButton';
import DescriptionText from 'Routes/Updrs/utils/DescriptionText';
import { isNumber } from 'neuro-utils';

const UPDRSV = ({ documents, startEdit, view }: IOwnProps): React.JSX.Element => (
  <HistorySection
    headerText={<FormattedMessage id={'updrs.updrsV'} />}
    newButton={
      <DocumentCreationButton
        name="updrs_v"
        text={'updrs.newUpdrsV'}
        onClick={startEdit({}, 'updrs_v')}
        width={15}
        height={3}
        fontSize={14}
        alternate={true}
      />
    }
    headerInfoText={<DescriptionText type={'updrsV'} />}
  >
    <HistoryRowListing
      documents={documents}
      headers={
        <>
          <Item xs={4}>
            <FormattedMessage id={'updrs.score'} />
          </Item>
          <Item xs={8}>
            <FormattedMessage id={'general.definition'} />
          </Item>
        </>
      }
      contentFormat={d => (
        <>
          <Item xs={4}>{isNumber(d.value) ? d.value : '-'}</Item>
          <Item xs={8} style={{ paddingRight: '1rem' }}>
            {isNumber(d.value) ? <FormattedMessage id={`updrs.opts.v.${d.value}`} /> : '-'}
          </Item>
        </>
      )}
      makeDate
      makeControls
      historyRowControls={d => <HistoryRowControls document={d} startEdit={startEdit} view={view} />}
    />
  </HistorySection>
);

interface IOwnProps {
  documents: IDocumentWithTypeV2<'updrs_v'>[];
  startEdit: StartEdit;
  view?: IView;
}

export default UPDRSV;
